import React, { createContext, useContext } from "react";

export interface FpsContextValue {
    fps: number;
    maxFps: number;
    isLoading: boolean;
    error: Error | null;
}

export const FpsContext = createContext<FpsContextValue | undefined>(undefined);

export const useFps = (): FpsContextValue => {
    const context = useContext(FpsContext);
    if (context === undefined) {
        throw new Error("useFps must be used within an FpsProvider");
    }
    return context;
};
